/**
 * District88 Identity Card — sync XP, level, culture, reputation from live activity.
 */
import { supabase } from '../lib/supabase';
import type { IdentityRefreshSnapshot } from '../lib/identitySystem';

const SYNC_STALE_MS = 15 * 60 * 1000;

export const identityService = {
  /** Recompute identity stats server-side (requires migration refresh_identity_card). */
  async refresh(userId: string): Promise<{ data: IdentityRefreshSnapshot | null; error: string | null }> {
    try {
      const { data, error } = await supabase.rpc('refresh_identity_card', { p_user_id: userId });
      if (error) {
        const msg = error.message || 'refresh_identity_card failed';
        if (/function.*does not exist|schema cache/i.test(msg)) {
          return { data: null, error: 'Identity sync not deployed — run latest Supabase migrations.' };
        }
        return { data: null, error: msg };
      }
      const snap = (typeof data === 'object' && data !== null ? data : {}) as IdentityRefreshSnapshot;
      if (snap.ok === false) {
        return { data: snap, error: snap.error || 'refresh failed' };
      }
      return { data: snap, error: null };
    } catch (e) {
      return { data: null, error: e instanceof Error ? e.message : 'Identity refresh failed' };
    }
  },

  shouldSync(lastSyncAt?: string | null): boolean {
    if (!lastSyncAt) return true;
    const t = Date.parse(lastSyncAt);
    if (Number.isNaN(t)) return true;
    return Date.now() - t > SYNC_STALE_MS;
  },
};
